import React from "react";
import { Link, useLocation } from "react-router-dom";

const LOGO_URL = "/santa-chiara-logo.png";

export default function Header() {
  const location = useLocation();
  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-30 w-full"
      style={{ backgroundColor: "#B8C5CD", borderBottom: "1px solid rgba(184, 153, 104, 0.18)" }}
    >
      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 flex items-center justify-center py-3" style={{ overflow: "visible" }}>
        <div data-testid="header-logo" className="select-none block" style={{ pointerEvents: "none" }}>
          <img
            src={LOGO_URL}
            alt="Santa Chiara"
            style={{ height: "clamp(64px, 7vw, 96px)", width: "auto", display: "block", margin: "0 auto" }}
          />
        </div>

        <nav className="absolute right-6 lg:right-12 top-1/2 -translate-y-1/2">
          <Link
            to="/"
            data-testid="nav-home-link"
            className="hidden sm:inline-block text-sm font-medium px-3 py-2 rounded-full transition"
            style={{ color: location.pathname === "/" ? "#2C2A28" : "#4A5A65" }}
          >
            Home
          </Link>
        </nav>
      </div>
    </header>
  );
}
